import {FC, useEffect} from 'react'
import {useLocation} from 'react-router'
import {DrawerComponent} from '../../assets/ts/components'
import {WithChildren} from '../../helpers'

const APP_VERSION = process.env.REACT_APP_VERSION

const Content: FC<WithChildren> = ({children}) => {
  const location = useLocation()
  useEffect(() => {
    DrawerComponent.hideAll()
  }, [location])

  return (
    <div id='kt_content_container' className='p-4'>
      {children}
      <p className='text-center text-muted fw-bold fs-6 mt-6'>{APP_VERSION}</p>
    </div>
  )
}

export {Content}
